// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  border-radius: 0 !important;
}

.content {
  padding: 1rem;
  margin-bottom: 1rem;
}

.field-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
}

.field-label {
  flex: 0 0 130px;
  margin: 0;
}

.field-value {
  flex: 1 1 auto;
  min-width: 0;
}

.date-pair {
  display: flex;
  align-items: center;
  gap: 12px;
}

.date-pair-label {
  flex: 0 0 auto;
  white-space: nowrap;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/edit-job/edit-job.component.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAAF;;AAGA;EACE,eAAA;EACA,SAAA;AAAF;;AAGA;EACE,cAAA;EACA,YAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAAF;;AAGA;EACE,cAAA;EACA,mBAAA;EACA,SAAA;AAAF","sourcesContent":[":host ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {\n  border-radius: 0 !important;\n}\n\n.content {\n  padding: 1rem;\n  margin-bottom: 1rem;\n}\n\n// Field layout — flexbox, no Bootstrap row negative margins\n.field-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.field-label {\n  flex: 0 0 130px;\n  margin: 0;\n}\n\n.field-value {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.date-pair {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.date-pair-label {\n  flex: 0 0 auto;\n  white-space: nowrap;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
